import styled from 'styled-components';

export const OptionItemSpriteListStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px 32px;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
`;

export const DominateOptionItemSpriteStyles = styled.div<{
  isSelected: boolean;
}>`
  box-sizing: border-box;
  height: 86px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 20px;
  background-color: ${({ isSelected }) =>
    isSelected ? '#AC0025' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  user-select: none;
`;

export const TitleContainerStyles = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 2;

  .option-item-sprite-subtitle {
    margin-top: 4px;
    opacity: 0.8;
  }
`;

export const OptionItemSpriteImageContainerStyles = styled.div<{
  isSelected?: boolean;
}>`
  width: 156px;
  height: 100%;
  aspect-ratio: 3.75;
  position: absolute;
  right: -12px;
  z-index: 1;
  font-size: 0;
  line-height: 0;

  img {
    width: 100%;
    height: 100%;
    filter: ${({ isSelected }) => (isSelected ? 'none' : 'grayscale(1)')};
    opacity: ${({ isSelected }) => (isSelected ? '1' : '0.7')};
    transition:
      filter 0.3s ease,
      opacity 0.3s ease;
  }
`;
